import { z } from 'zod';

import { t } from '@/lib/utils';
import { useCountryStore } from '@/stores/countryStore';

export function validateVAT(vatNumber: string, countryCode: string): boolean {
    const { vatRegexPatterns } = useCountryStore.getState();
    const patternString = vatRegexPatterns[countryCode.toUpperCase()];
    if (!patternString) {
        return false;
    }
    const pattern = new RegExp(patternString);
    return pattern.test(vatNumber);
}

export const AdditionalVatSchema = () =>
    z
        .object({
            vat: z.string().min(1, t('general.atLeastOneLetterOrNumber')),
            country: z.string().min(2, t('general.selectOneCountry')),
            permanentEstablishment: z.string(),
        })
        .refine(val => validateVAT(val.vat, val.country), {
            message: t('general.invalidVAT'),
            path: ['vat'],
        })
        .array();

export type AdditionalVatSchemaType = z.infer<ReturnType<typeof AdditionalVatSchema>>;
